/**
 * Dose log screen - list of dose entries
 */

import React from 'react';
import { View, Text, StyleSheet, FlatList } from 'react-native';
import { useDoseStore } from '../store';
import { DoseCard } from '../components';

export function DoseLogScreen() {
  const logs = useDoseStore((s) => s.logs);
  const getTotalMicroSv = useDoseStore((s) => s.getTotalMicroSv);
  const total = getTotalMicroSv();

  return (
    <View style={styles.container} testID="dose-log-screen">
      <Text style={styles.title} testID="dose-log-title">Dose Log</Text>
      <DoseCard doseMicroSv={total} label="Total" />
      <FlatList
        data={[...logs].reverse()}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <View style={styles.logItem}>
            <Text style={styles.logDate}>
              {new Date(item.createdAt).toLocaleDateString()}
            </Text>
            <Text style={styles.logDose}>
              {item.effectiveDoseMicroSv} µSv ({item.source})
            </Text>
          </View>
        )}
        ListEmptyComponent={
          <Text style={styles.empty}>No dose entries yet.</Text>
        }
      />
    </View>
  );
}

const styles = StyleSheet.create({
  container: { flex: 1, padding: 20 },
  title: { fontSize: 24, fontWeight: '700', marginBottom: 16 },
  logItem: {
    padding: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  logDate: { fontSize: 14, color: '#666' },
  logDose: { fontSize: 16, fontWeight: '500', marginTop: 4 },
  empty: { padding: 20, color: '#888', textAlign: 'center' },
});
